import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=46f33ac4&scoped=true&lang=pug&"
import script from "./Paragraph.vue?vue&type=script&lang=js&"
export * from "./Paragraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f33ac4",
  null
  
)

export default component.exports